import { Component } from '@angular/core';
import { MainBtnComponent } from '../../../shared/UI/main-btn/main-btn.component';

@Component({
  selector: 'app-cover-static-revision',
  imports: [  
      // MainBtnComponent ,
  ],
  templateUrl: './cover-static-revision.component.html',
  styleUrl: './cover-static-revision.component.css'
})
export class CoverStaticRevisionComponent {

}
